<script>
  export default {
    name: "NotFound",
    render: function (createElement, context) {
      window.location.href = '/';
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NotFound.vue